import PageTop from '@root/modules/Sellers/Dashboard/components/PageTop/index';
import useTranslate from '@core/hooks/useTranslate';
import Statistics from '@root/core/components/TotalNumber';
import { Col, Divider, Row, Typography } from 'antd';
import { Header } from 'antd/lib/layout/layout';
import EditMember from '../components/EditMember';
import MemberRequest from '../components/MemberRequest';
import buskService from '../services/dashboard';
import { useEffect, useState } from 'react';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import moment from 'moment';
import { formatDateTime } from '@root/utils/helpers/formatDate';

interface Props {}

const breadcrumbList = [
  {
    tittle: '대시보드',
    url: '/admin/busk'
  }
];

const BuskAdminDashboard = (props: Props) => {
  const [t] = useTranslate();

  const [totalInfo, setTotalInfo] = useState<{}[]>([]);

  const [signupRequest, setSignupRequest] = useState([]);

  const [amendmentRequest, setAmendmentRequest] = useState<{}[]>([]);

  const getTotalInfo = async () => {
    const buskTotalInfo = await buskService.getTotalInfo();
    setTotalInfo(buskTotalInfo.data);
  };

  const getSignupRequest = async () => {
    const buskSignupRequest = await buskService.getSignupRequest();
    const rowDataModified = buskSignupRequest.data.signupRequest?.map(
      (r: any, index: number) => {
        return {
          ...r,
          key: index,
          // updatedAt: new Date(r?.updatedAt).toLocaleString('ko-KR')
          updatedAt: formatDateTime(r.updatedAt)
        };
      }
    );
    setSignupRequest(rowDataModified);
  };

  const getAmendmentRequest = async () => {
    const buskAmendmentRequest = await buskService.getAmendmentRequest();
    const rowDataModified = buskAmendmentRequest.data.amendmentRequest?.map(
      (r: any) => {
        return {
          ...r,
          updatedAt: new Date(r?.updatedAt).toLocaleString('ko-KR')
        };
      }
    );
    setAmendmentRequest(rowDataModified);
  };

  useEffect(() => {
    getTotalInfo();
    getSignupRequest();
    getAmendmentRequest();
  }, []);

  return (
    <>
      <div className="busk-container-breadcrumb">
        <BreadcrumbList listBreadcrumb={breadcrumbList} />
      </div>
      <div className="busk-container">
        <div className="site-card-wrapper" style={{ marginBottom: '1.5rem' }}>
          <Row gutter={12}>
            {totalInfo?.map((t: any, index: number) => (
              <Statistics key={index} title={t.title} number={t.amount} />
            ))}
          </Row>
        </div>
        <Row gutter={0}>
          <Col
            flex={4}
            style={{
              backgroundColor: 'white',
              minHeight: '60vh',
              marginRight: '1rem'
            }}
          >
            <Typography.Title level={4} style={{ padding: '1rem 2rem' }}>
              회원 가입 요청
            </Typography.Title>
            <Divider style={{ margin: 0 }} />
            {signupRequest.map((sur: any) => (
              <MemberRequest
                key={sur.id}
                id={sur.id}
                name={sur.name}
                role={sur.role}
                status={sur.status}
                updatedAt={sur.updatedAt}
              />
            ))}
          </Col>

          <Col flex={1} style={{ backgroundColor: 'white', minHeight: '60vh' }}>
            <Typography.Title level={4} style={{ padding: '1rem 2rem' }}>
              회원정보 수정 요청
            </Typography.Title>
            <Divider style={{ margin: 0 }} />
            {amendmentRequest?.map((amr: any) => (
              <EditMember
                key={amr.id}
                id={amr.id}
                name={amr.name}
                role={amr.role}
                updatedAt={amr.updatedAt}
              />
            ))}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default BuskAdminDashboard;
